module.exports = __webpack_public_path__ + "assets/images/JPY10000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JPY10000.png
// module id = 1409
// module chunks = 1